const ADDITIONAL_OFFER = 'additional-offer';
const MATERIAL_OFFER = 'material-offer';
const OFFER = 'offer';
const PRELIMINARY_OFFER = 'preliminary-offer';
// A sales opportunity: basic information and estimated sums, no calculation
const OPPORTUNITY = 'opportunity';

export {
  ADDITIONAL_OFFER,
  MATERIAL_OFFER,
  OFFER,
  OPPORTUNITY,
  PRELIMINARY_OFFER,
};
